export default {
  fetchDataFailed: "加载用户数据失败，请重试或联系支持",
  password_changed_other_tab: "密码已在其他标签页更新",
  profile_updated_other_tab: "个人资料已在其他标签页更新",
  report_updated_other_tab: "报告配置已在其他标签页更新。",
  logged_out_other_tab: "您已在其他标签页登出",
  oauth: {
    processing: "正在处理登录请求...",
  },
  ticket: {
    modal_title: "提交工单",
    not_logged_in: "请先登录",
    login_required: "提交工单需要登录账户。您是否要前往登录页面？",
    go_to_login: "前往登录",
    submit_success: "工单提交成功！我们的支持团队将在24-48小时内回复。",
    email: "邮箱",
    email_placeholder: "请输入您的邮箱",
    type: "问题类型",
    type_placeholder: "请选择问题类型",
    subject: "主题",
    subject_placeholder: "请输入工单主题（5-100个字符）",
    description: "问题描述",
    description_placeholder: "请详细描述问题",
    submit_ticket: "提交工单",
    submit_failed: "提交工单失败！",
    email_send_failed_title: "邮件通知问题",
    email_send_failed_desc:
      "您的工单已成功提交，但我们在发送邮件通知时遇到问题。我们的支持团队仍会处理您的请求。",
  },
};
